import React from 'react';

/**
 * AuthShell — the branded chrome around every pre-login page (sign in, set password, no access,
 * accept invitation, the OAuth callback screen). Previously each of the 5 auth pages hand-wrote
 * an identical `d-flex align-items-center justify-content-center bg-light` wrapper around a bare
 * Bootstrap `card shadow-lg`, with none of the app's own `np-*` system or brand identity - the
 * first thing anyone sees on this app looked like an unstyled template. Only the chrome is
 * shared; each page keeps its own state, Cognito calls, and redirects completely untouched.
 */
export const AuthShell: React.FC<{ children: React.ReactNode; maxWidth?: number }> = ({ children, maxWidth = 460 }) => (
  <div className="auth-shell">
    <div className="auth-card" style={{ maxWidth }}>
      <div className="auth-brand">
        <span className="auth-brand-mark"><i className="ri-cloud-line"></i></span>
        <span className="auth-brand-word">Mercell Nimbus</span>
      </div>
      {children}
    </div>
  </div>
);
